import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { ContextService } from '../../core/context/context.service';

@Component({
    template: `{{value | pgsCurrency:true }}`,
})
export class CustomPriceCellComponent implements OnInit, OnDestroy {
    @Input() rowData: any;
    @Input() value: number;

    change: Observable<any>;
    customInput: string;
    map: (value: string) => any;

    constructor(private contextService: ContextService, private changeDetectorRef: ChangeDetectorRef) { }

    ngOnInit(): void {
        if (this.change) {
            this.change.subscribe(
                value => {
                    if (this.map) {
                        const newVal = this.map(this.rowData[this.customInput]);
                        this.value = newVal;
                        this.rowData[this.customInput] = newVal;
                    } else {
                        this.value = this.rowData[this.customInput];
                    }

                    if (!this.changeDetectorRef['destroyed']) {
                        this.changeDetectorRef.detectChanges();
                    }
                }
            );
        }
    }

    ngOnDestroy(): void {
        this.changeDetectorRef.detach();
    }

}
